// components.application.rewards.achievementCard.claimPointsModal

export const CLAIM_POINTS_MODAL = {
  congrats: 'CONGRATS!',
  earned: 'You earned {{value}} points.',
  balance: 'You total is now {{newBalance}} points.',
  shareButton: 'SHARE'
};
